import {Component, Input, OnInit} from '@angular/core';
import {BaseModal} from '@ui-app/modals/base-modal';

@Component({
    selector: 'employee-ui-badge-lost-modal',
    templateUrl: './badge-lost-modal.component.html',
    styleUrls: ['./badge-lost-modal.component.less']
})
export class BadgeLostModalComponent extends BaseModal implements OnInit{
    @Input() buttonsTitle = {
        close: 'Ok'
    };
    @Input() reasonId: number;
    text: string;
    beginningOfText: string;

    ngOnInit(): void {
        if (this.reasonId === 2) {
            this.beginningOfText = "Badge lost";
            this.text = 'Once the badge lost request is submitted, the lost badge will be de-activated.';
        }
        if (this.reasonId === 3) {
            this.beginningOfText = "Badge stolen";
            this.text = 'Once the badge stolen request is submitted, the stolen badge will be de-activated.';
        }
    }
}
